import { Text } from '@ltvco/refresh-lib/theme';
import { useCallback, useState, useRef, useEffect } from 'react';

import {
  ClickHereTooltipArrow,
  ClickHereTooltipContainer,
} from 'components/DeepSearch/components/components';

interface ClickHereTooltipProps {
  children: React.ReactNode;
}

export const ClickHereTooltip = ({ children }: ClickHereTooltipProps) => {
  const [open, setOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, handleClickOutside]);

  return (
    <span
      ref={tooltipRef}
      style={{
        position: 'relative',
        display: 'inline-block',
        cursor: 'pointer',
        textDecoration: 'underline',
        color: 'inherit',
      }}
      onClick={handleClick}
    >
      {children}
      {open && (
        <ClickHereTooltipContainer>
          <ClickHereTooltipArrow />
          <Text
            fontSize="13px"
            color="white"
            sx={{ mb: 1 }}
            textAlign="justify"
          >
            This chat feature is powered by artificial intelligence.
            BeenVerified is not responsible for any decisions, actions, or
            outcomes based on the information provided by the AI. The
            information provided or contained in any report and on our website
            is not necessarily 100% accurate, complete or up to date, nor a
            substitute for your own due diligence, especially concerning such
            sensitive items as criminal history, relatives, mortgages and liens.
            Our data comes from a wide variety of sources, but some
            municipalities and jurisdictions are slow to report and digitize
            their data, so we cannot guarantee or warrant full accuracy of ALL
            search results.
          </Text>
          <Text fontSize="13px" color="white" textAlign="justify">
            BeenVerified's mission is to give people easy and affordable access
            to public record information, but BeenVerified does not provide
            private investigator services or consumer reports, and is not a
            consumer reporting agency per the Fair Credit Reporting Act. You may
            not use our site or service or the information provided to make
            decisions about employment, admission, consumer credit, insurance,
            tenant screening or any other purpose that would require FCRA
            compliance. For more information governing permitted and prohibited
            uses, please review our "Do's & Don'ts" and our Terms & Conditions.
          </Text>
        </ClickHereTooltipContainer>
      )}
    </span>
  );
};
